export default __webpack_public_path__ + "static/media/ndvi.af04bad2.png";